const sign = {
  path: 'common/sign/:userKey/:signKey',
  props: true,
  component: resolve => require(['../../../pages/common/sign'], resolve)
}

export default sign
